import { defineStore, acceptHMRUpdate } from "pinia";
import { createTranslationHighlightField } from "../lib/createTranslationHighlightField";

export const useTranslationNonIncluded = defineStore(
  "translation-content-non-included-field",
  createTranslationHighlightField({
    fieldId: "non_included",
    isRequired: false,
    highlightKey: "non_included",
    customKey: "custom_non_included",
    premadeKey: "premade_non_included",
  })
);

// HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationNonIncluded, import.meta.hot));
}
